export default "__VITE_ASSET__DeaAgMeZ__"